import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _objectSpread from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    var _this = this;

    return {
      form: {
        id: "",
        flag: "",
        language: "",
        desc: ""
      },
      dataForm: {
        language: '',
        address: '',
        cooperationPic: '',
        email: '',
        latitude: 0,
        longitude: 0,
        name: '',
        postcode: ''
      },
      picfileList: [],
      rules: {
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        address: [{
          required: true,
          message: "请输入地址",
          trigger: "blur"
        }],
        cooperationPic: [{
          required: true,
          message: "请上传二维码图",
          trigger: "blur"
        }],
        email: [{
          required: true,
          message: "请输入邮箱",
          trigger: "blur"
        }],
        latitude: [{
          validator: function validator(rule, value, callback) {
            if (value === '' || !_this.dataForm.longitude) {
              callback(new Error('请完善经纬度'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: "请输入公司名称",
          trigger: "blur"
        }],
        postcode: [{
          required: true,
          message: "请输入邮政编码",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$refs.newPopover.open();

                if (data) {
                  _this2.form = {
                    id: data.id,
                    flag: data.flag,
                    language: data.language,
                    desc: data.desc
                  };
                  _this2.dataForm = _objectSpread(_objectSpread({}, JSON.parse(data.desc)), {}, {
                    language: data.language
                  });

                  _this2.$nextTick(function () {
                    _this2.$refs.picUploadImage.echos(_this2.dataForm.cooperationPic);
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    picUrl: function picUrl(e) {
      this.picfileList = e;
      this.dataForm.cooperationPic = e.toString();
    },
    clearData: function clearData(id) {
      this.dataForm = {
        language: this.form.language,
        address: '',
        cooperationPic: '',
        email: '',
        latitude: 0,
        longitude: 0,
        name: '',
        postcode: ''
      };
      this.$refs.picUploadImage.emptyFeil();
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this3.form.desc = JSON.stringify(_this3.dataForm); // let reqFn = this.form.id ? 'updWebDescriptions' : 'addWebDescriptions'

          _this3.$api.updWebDescriptions(_this3.form).then(function (res) {
            if (res.code == 0) {
              _this3.$message({
                message: '操作成功',
                type: 'success'
              });

              _this3.$refs.newPopover.hide();

              _this3.$emit('change');
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};